import { gql } from '@/Types/gql';

export const GET_SESSION_BY_ID = gql(`query GetSessionById($id: ID!) {
  getSessionById(_id: $id) {
    _id
    sessionStartTime
    sessionEndTime
    sessionStatus
    programId
    sportId
    position
    programDetails{
    programName
    }
    sessionUniqId
    assesment {
      _id
      createdAt
      updatedAt
      traineeId
      trainerId
      sessionId
      assessment
      __typename
    }
    status
    trainingType {
      _id
      title
      icon
    }
    trainerId
    trainerExpertiseRating
    trainerIdUser {
      _id
      about
      averageRating
      dateOfBirth
      firstName
      lastName
      profileImage
      specializations {
        _id
        title
      }
      medias {
        _id
        path
        type
      }
    }
    traineeId
    traineeIdUser {
        _id
        ageRange
        firstName
        lastName
        displayName
        dateOfBirth
        height
        weight
        profileImage(
          formats: {
            edits: { resize: { width: 160, height: 160, fit: "cover" } }
          }
        )
        gender
        weightType
        heightType
        fitnessGoals
        injury {
          status
          description
        }
        preferredWorkouts {
          _id
          title
        }
        equipments
        currentEngagements {
          status
          description
        }
        workoutPreference
      }
    traineeRating
    timeZone
  }
}`);

export const GET_OVERALL_ASSESSMENT = gql(`
  query GetOverAllAssessment($traineeId: ID!) {
  getOverAllAssessment(traineeId: $traineeId)
}
`);

export const GET_ONE_SESSION = gql(`query GetOneSession($filter: JSON, $sort: JSON) {
  getOneSession(filter: $filter, sort: $sort) {
    _id
    sessionStartTime
    sessionEndTime
    lastTrainerDtls {
          _id
          displayName
          firstName
          lastName
          profileImage
        }
    assesment {
    _id
      assessment
    }
    clientPerformance
    targetedMuscle
    clientFeedback
    exercisePerformed
    trainingType {
      title
    }
    trainerIdUser {
      _id
      profileImage(
        formats: {
          edits: { resize: { width: 25, height: 25, fit: "cover" } }
        }
      )
      displayName
      firstName
      lastName
    }
    programName
    programId
  }
}`);

export const NOTES_FROM_PREVIOUS_SESSIONS =
  gql(`query GetNotesFromPreviosSessions($search: String, $filter: JSON, $sort: JSON, $limit: Int, $offset: Int, $formats: JSON) {
  getNotesFromPreviosSessions(search: $search, filter: $filter, sort: $sort, limit: $limit, offset: $offset) {
    clientFeedback
    _id
    sessionStartTime
    sessionEndTime
    trainerIdUser {
      _id
      profileImage(formats: $formats)
      displayName
    }
  }
}`);
